// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"346efcf6","553":"aa0ebc3f","977":"6cf2aa51"}[chunkId] + ".chunk.js";
};